import { Box, Button, Stack, Typography, useTheme } from '@mui/material'

import libbyPeekingSrc from '~/assets/images/libby/libby-closed-eyes-gray.svg'
import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { isLibbyDomain } from '~/features/partners/utils'
import useErrorRedirect from '~/hooks/useErrorRedirect'

type TProps = {
  resetErrorBoundary?: () => void
}
function ErrorFallback({ resetErrorBoundary = () => undefined }: TProps) {
  const theme = useTheme()
  const { redirectToSafety } = useErrorRedirect()
  const isPartner = useIsPartner() || !isLibbyDomain()

  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        padding: 20,
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {!isPartner && (
        <Box
          component="img"
          src={libbyPeekingSrc}
          alt="Libby Peeking"
          width={200}
        />
      )}
      <Typography
        variant="h4"
        sx={{
          fontWeight: theme.typography.fontWeightBold,
        }}
      >
        Oops, something went wrong
      </Typography>

      <Button
        variant="secondary"
        onClick={() => {
          resetErrorBoundary()
          redirectToSafety()
        }}
      >
        Go back to homepage
      </Button>
    </Stack>
  )
}
export default ErrorFallback
